import { FieldModel } from '../extraction-models';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

// TODO: Can we somehow rewrite this to either only write the key once or guarantee that the keys match?
export const Forderungen = {
  forderungen_beschreibung: {
    key: 'forderungen_beschreibung',
    label: { text: 'Beschreibung', genus: 'F' },
    type: FieldType.STRING,
    index: 0,
    widthUtilityClass: 'w-5/12',
    validators: [Validations.required()],
    customTransformValue: (v) =>
      v.replace(/- ([a-zA-ZäöüÄÖÜß])/g, (_, letter) => letter.toLowerCase()).trim(),
  },
  forderungen_von: {
    key: 'forderungen_von',
    label: { text: 'Von', genus: 'M' },
    type: FieldType.DATE,
    index: 1,
    widthUtilityClass: 'w-2/12',
    validators: [Validations.required(), Validations.date()],
  },
  forderungen_bis: {
    key: 'forderungen_bis',
    label: { text: 'Bis', genus: 'M' },
    type: FieldType.DATE,
    index: 2,
    widthUtilityClass: 'w-2/12',
    validators: [Validations.date()],
  },
  forderungen_betrag: {
    key: 'forderungen_betrag',
    label: { text: 'Betrag', genus: 'M' },
    type: FieldType.CURRENCY,
    index: 3,
    widthUtilityClass: 'w-4/12',
    validators: [Validations.required()],
  },
} as const satisfies Record<string, FieldModel>;
